export enum InputVariant {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Slim = 'slim',
    Transparent = 'transparent',
    Rounded = 'rounded',
    outline = 'outline',
}
